
import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
import { ScrollReveal } from '@/components/ui/premium';

export const HeroScrollIndicator = () => {
  return (
    <ScrollReveal animation="fade" delay={2}>
      <motion.div
        className="flex flex-col items-center text-brand-primary/60"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
      >
        <span className="text-sm mb-2">Explore mais</span>
        <ArrowDown className="w-5 h-5" />
      </motion.div>
    </ScrollReveal>
  );
};
